import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FieldConfig } from '../../models/common-models';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { config } from 'rxjs';

@Component({
  selector: 'app-form-checkbox',
  templateUrl: './form-checkbox.component.html',
  styleUrls: ['./form-checkbox.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FormCheckboxComponent implements OnInit {

  config: FieldConfig;
  group: FormGroup;
  configName: any;
  innerHTMLdata: boolean = false;
  constructor() { }

  ngOnInit() {
    this.configName = this.group.get(this.config.name);   
    this.innerHTMLdata = this.config.innerHTMLdata ? this.config.innerHTMLdata : false;
  }

}
